"use strict";import o from"./src/spectrum-base.css.js";import t from"./src/spectrum-lang.css.js";import r from"./src/spectrum-body.css.js";export default[o,t,r];
//# sourceMappingURL=body.js.map
